export default class EmailTaken extends Error {
  super(message) {
    this.message = message;
    this.name = 'EmailTaken';
  }
}
